<style scoped>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row">
            <!--<div class="col-xl-3 col-lg-4">
                <div class="m-portlet m-portlet--full-height  ">
                    <div class="m-portlet__body">
                        <div class="m-card-profile">
                            <div class="m-card-profile__title m--hide">
                                {{$t('Your Profile')}}
                            </div>
                            <div class="m-card-profile__pic">
                                <div class="m-card-profile__pic-wrapper">
                                    <img src="../../../../static/app/media/img/users/default-user.png" alt=""/>
                                </div>
                            </div>
                            <div class="m-card-profile__details">
                                                <span class="m-card-profile__name">
                                                    {{user.lastname}} {{user.firstname}}
                                                </span>
                                <a href="" class="m-card-profile__email m-link">
                                    {{user.email}}
                                </a>
                            </div>
                        </div>
                        <div class="m-portlet__body-separator"></div>
                    </div>
                </div>
            </div>-->
            <div class="col-xl-12 col-lg-12">
                <div class="m-portlet m-portlet--full-height m-portlet--tabs  ">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-tools">
                            <ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
                                role="tablist">
                                <li class="nav-item m-tabs__item">
                                    <a class="nav-link m-tabs__link active" data-toggle="tab"
                                       href="#m_user_profile_tab_1" role="tab">
                                        <i class="flaticon-share m--hide"></i>
                                        {{$t('Update Profile')}}
                                    </a>
                                </li>
                                <li class="nav-item m-tabs__item" v-if="profile === true">
                                    <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_2"
                                       role="tab">
                                        {{$t('Roles')}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="tab-content">
                        <div class="tab-pane active" id="m_user_profile_tab_1">
                                <div class="m-portlet__body">
                                    <div class="form-group m-form__group row">
                                        <div class="col-10 ml-auto">
                                            <h3 class="m-form__section">
                                                1. {{$t('Personal Details')}}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('firstname')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Firstname')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.firstname">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('firstname')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('lastname')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Lastname')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.lastname">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('lastname')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('email')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Email')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.email">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('email')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('password')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Password')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="password" v-model="user.password">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('password')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('password_again')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Password again')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="password" v-model="user.password_again">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('password_again')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                                    <div class="form-group m-form__group row">
                                        <div class="col-10 ml-auto">
                                            <h3 class="m-form__section">
                                                2. {{$t('Shipping details')}}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('name', 'shipping')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Shipping name')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.shipping.name">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('name', 'shipping')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5">
                                            <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('country', 'shipping')}">
                                                <label  class="col-5 col-form-label">
                                                    {{$t('Shipping country')}}
                                                </label>
                                                <div class="col-7">
                                                    <input class="form-control m-input" type="text" v-model="user.shipping.country">
                                                    <div class="form-control-feedback">
                                                        <span v-for="message in filter('country', 'shipping')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('zip', 'shipping')}">
                                                <label  class="col-5 col-form-label">
                                                    {{$t('Shipping zip')}}
                                                </label>
                                                <div class="col-7">
                                                    <input class="form-control m-input" type="text" v-model="user.shipping.zip">
                                                    <div class="form-control-feedback">
                                                        <span v-for="message in filter('zip', 'shipping')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('city', 'shipping')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Shipping city')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.shipping.city">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('city', 'shipping')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('address', 'shipping')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Shipping address')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.shipping.address">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('address', 'shipping')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('phone', 'shipping')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Phone')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.shipping.phone">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('phone', 'shipping')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                                    <div class="form-group m-form__group row">
                                        <div class="col-10 ml-auto">
                                            <h3 class="m-form__section">
                                                3. {{$t('Billing details')}}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('name', 'billing')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Billing name')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.billing.name">
                                            <div class="form-control-feedback">
                                            <span v-for="message in filter('name', 'billing')" v-bind:key="message">
                                                {{message}} <br/>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5">
                                            <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('country', 'billing')}">
                                                <label  class="col-5 col-form-label">
                                                    {{$t('Billing country')}}
                                                </label>
                                                <div class="col-7">
                                                    <input class="form-control m-input" type="text" v-model="user.billing.country">
                                                    <div class="form-control-feedback">
                                                        <span v-for="message in filter('country', 'billing')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('zip', 'billing')}">
                                                <label  class="col-5 col-form-label">
                                                    {{$t('Billing zip')}}
                                                </label>
                                                <div class="col-7">
                                                    <input class="form-control m-input" type="text" v-model="user.billing.zip">
                                                    <div class="form-control-feedback">
                                                        <span v-for="message in filter('zip', 'billing')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('city', 'billing')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Billing city')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.billing.city">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('city', 'billing')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('address', 'billing')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Billing address')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.billing.address">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('address', 'billing')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row" v-bind:class="{'has-danger': hasError('tax_number', 'billing')}">
                                        <label  class="col-2 col-form-label">
                                            {{$t('Tax Number')}}
                                        </label>
                                        <div class="col-7">
                                            <input class="form-control m-input" type="text" v-model="user.billing.tax_number">
                                            <div class="form-control-feedback">
                                                        <span v-for="message in filter('tax_number', 'billing')" v-bind:key="message">
                                                            {{message}} <br/>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Buttons v-on:save="save" :list-link="`/admin/user/index`"></Buttons>
                        </div>
                        <div class="tab-pane " id="m_user_profile_tab_2" v-if="profile === true">
                            <div class="m-portlet__body">
                                <div class='form-group m-form__group row'>
                                    <div class='col-lg-6 m-form__group-sub'>
                                        <label class='form-control-label'>
                                            {{$t('Roles')}}:
                                        </label>
                                        <div class='m-checkbox-list'>
                                            <label class='m-checkbox' v-for='(value, key) in roles.data'
                                                   v-bind:key='key'>
                                                <input type='checkbox' :id="value.id" :value='value.id' v-model="user.roles">
                                                {{value.name}}
                                                <span></span>
                                            </label>
                                        </div>
                                        <span class='m-form__help'>
                                                                {{$t('Please select user group')}}
                                                             </span>
                                    </div>
                                </div>
                            </div>
                            <Buttons v-on:save="save" :list-link="`/admin/user/index`"></Buttons>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'

export default {
  name: 'UserForm',
  components: {Buttons},
  props: ['user', 'errors', 'url', 'props', 'profile', 'roles'],
  watch: {
    user: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
      },
      deep: true
    }
  },
  methods: {
    hasError (val, node = null) {
      if (node == null) {
        for (let er in this.errors) {
          if (er === val) {
            return true
          }
        }
      } else {
        for (let er in this.errors) {
          if (er === node + '.' + val) {
            return true
          }
        }
      }

      return false
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name, node = null) {
      if (name === 'undefined') return ''
      if (node == null) {
        for (let er in this.errors) {
          if (er === name) {
            this.hasDanger = true
            return this.errors[er]
          }
        }
      } else {
        for (let er in this.errors) {
          if (er === node + '.' + name) {
            this.hasDanger = true
            return this.errors[er]
          }
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/user/UserForm.vue